import {UntypedFormControl} from '@angular/forms';

export function validateIssnFormat(control: UntypedFormControl) {
    const issnFormat = control.value as string;
    if (issnFormat && !(issnFormat.match(/^[0-9]{4}-?[0-9]{3}[0-9|X|x]$/))){
        return { validateIssnFormat: true };
    }
    return null;
}
